import type { ReactNode } from "react";

import { Alert, Divider, Heading } from "@stacklet/ui";

/** Props for the IdpManagedNotice component */
interface Props {
  /** Heading for the section the notice stands in for, e.g. "Users" */
  title: string;
  /** Explanation of what the identity provider owns and why it's read-only */
  children: ReactNode;
}

/**
 * Stands in for an editor that an identity provider owns: keeps the section
 * heading in place and says why there is nothing to edit, rather than hiding
 * the section and leaving the user to guess.
 */
export function IdpManagedNotice({ title, children }: Props) {
  return (
    <div className="flex w-full flex-col">
      <Heading className="text-label-medium-strong text-text-primary" level={3}>
        {title}
      </Heading>
      <Divider className="mt-xs" />
      <Alert className="mt-md" severity="secondary">
        {children}
      </Alert>
    </div>
  );
}
